/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


function myFunction() {
    var input, filter, ul, li, a, i, txtValue, searchclose;
    input = document.getElementById("myInput");
    searchclose = document.getElementById("close-search");
  if(input){
    filter = input.value.toUpperCase();
    ul = document.getElementById("myUL");
    li = ul.getElementsByTagName("li");
       for (i = 0; i < li.length; i++) {
        a = li[i].getElementsByTagName("a")[0];
        txtValue = a.textContent || a.innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
            li[i].style.display = "";
        } else {
            li[i].style.display = "none";
        }
    }
  
  }
  
 
}

//$(document).ready(function(){
$("#close-search").click(function(){
  $('#myUL').hide();
  $(this).hide();
});

$(".customSearh input").focus(function(){
  $('#myUL').show();
  $("#close-search").attr("style", "display:block");
});
//});



$(document).ready(function() {
  if ($(window).width() >= 768) {
    $('.customSearh').remove().insertAfter($('.Slideshow__Content.Slideshow__Content--middleLeft'));
  } else {
   // $('.container-one-half-right.desktop').remove().insertBefore($('.Product__InfoWrapper'));
  }
});


